import React from 'react';
import { Link } from 'react-router-dom';
import logoAgsus from '../../../../theme/logo-agsus.png';

// O tamanho na tela vem do CSS (.ag-topbar__logo img). width/height aqui são as
// dimensões do arquivo: só dão a proporção, para o navegador reservar o espaço
// antes de a imagem carregar.
const Logo = () => (
  <Link to="/" title="AgSUS — Agência Brasileira de Apoio à Gestão do SUS">
    <img src={logoAgsus} alt="AgSUS" width="2560" height="781" />
  </Link>
);

export default Logo;
